import { render, staticRenderFns } from "./sharePlan.vue?vue&type=template&id=f652f240&scoped=true&"
import script from "./sharePlan.vue?vue&type=script&lang=js&"
export * from "./sharePlan.vue?vue&type=script&lang=js&"
import style0 from "./sharePlan.vue?vue&type=style&index=0&id=f652f240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f652f240",
  null
  
)

export default component.exports